import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import DevisForm from "@/components/DevisForm";

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const Contact = () => (
  <>
    <Seo
      title="Contact & devis — ATLAS THD"
      description="Contactez ATLAS THD pour un raccordement fibre optique ou un contrôle qualité : 06 05 76 50 66 ou Contact.pro@atlasthd.com. Réponse rapide."
    />

    <section className="border-b border-line bg-cloud" data-testid="contact-hero">
      <div className="bg-blueprint">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-24 lg:px-8">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-display text-xs font-bold uppercase tracking-[0.25em] text-steel"
          >
            Contact
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="mt-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-midnight sm:text-5xl"
          >
            Parlons de votre projet fibre ou contrôle qualité
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-steel"
          >
            Décrivez votre besoin via le formulaire, ou appelez-nous
            directement : une équipe technique vous répond rapidement.
          </motion.p>
        </div>
      </div>
    </section>

    <section className="bg-white py-16 lg:py-24" data-testid="contact-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-5 lg:gap-16 lg:px-8">
        <motion.div {...fadeUp} transition={{ duration: 0.5 }} className="lg:col-span-2">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-steel">
            Appel direct
          </p>
          <a
            href="tel:+33605765066"
            data-testid="contact-phone-link"
            className="mt-3 block font-display text-4xl font-extrabold tracking-tight text-midnight transition-colors hover:text-terrain sm:text-5xl"
          >
            06 05 76 50 66
          </a>
          <div className="mt-10 space-y-px border border-line bg-line">
            <a
              href="tel:+33605765066"
              data-testid="contact-card-phone"
              className="flex items-center gap-4 bg-white p-6 transition-colors hover:bg-cloud"
            >
              <Phone className="h-6 w-6 shrink-0 text-terrain" />
              <div>
                <p className="font-display text-sm font-bold uppercase tracking-wider text-midnight">Téléphone</p>
                <p className="mt-1 text-sm text-steel">06 05 76 50 66 — du lundi au vendredi</p>
              </div>
            </a>
            <a
              href="mailto:Contact.pro@atlasthd.com"
              data-testid="contact-card-email"
              className="flex items-center gap-4 bg-white p-6 transition-colors hover:bg-cloud"
            >
              <Mail className="h-6 w-6 shrink-0 text-terrain" />
              <div>
                <p className="font-display text-sm font-bold uppercase tracking-wider text-midnight">E-mail</p>
                <p className="mt-1 text-sm text-steel">Contact.pro@atlasthd.com</p>
              </div>
            </a>
            <div className="flex items-center gap-4 bg-white p-6" data-testid="contact-card-zone">
              <MapPin className="h-6 w-6 shrink-0 text-terrain" />
              <div>
                <p className="font-display text-sm font-bold uppercase tracking-wider text-midnight">Zone d'intervention</p>
                <p className="mt-1 text-sm text-steel">Toute la France</p>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div {...fadeUp} transition={{ duration: 0.5, delay: 0.15 }} className="lg:col-span-3">
          <div className="border border-line bg-cloud p-6 sm:p-10">
            <h2 className="font-display text-2xl font-extrabold tracking-tight text-midnight">
              Votre projet
            </h2>
            <p className="mb-8 mt-2 text-sm text-steel">
              Raccordement FTTO/FTTH, inspection, audit, suivi QHSE ou
              remontées VQSE : indiquez-nous votre besoin, nous l'étudions
              avec vous.
            </p>
            <DevisForm />
          </div>
        </motion.div>
      </div>
    </section>
  </>
);

export default Contact;
